module.exports = __webpack_public_path__ + "static/media/Anlook.e6b06758.svg";